import React, { useEffect, useState } from "react";
import { Select, TextInput, Textarea, FileInput, Button } from "@mantine/core";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { IconMinus, IconPlus } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";

const Inheritance = () => {
  const [accountType, setAccountType] = useState("Email");
  const [accounts, setAccounts] = useState([{ type: "", value: "" }]);
  const location = useLocation();

  const addAccount = () => {
    setAccounts([...accounts, { type: "", value: "" }]);
  };

  const removeAccount = (index) => {
    const newAccounts = accounts.filter((_, i) => i !== index);
    setAccounts(newAccounts);
  };

  const handleTypeChange = (index, type) => {
    const newAccounts = [...accounts];
    newAccounts[index].type = type;
    setAccounts(newAccounts);
  };

  const handleValueChange = (index, value) => {
    const newAccounts = [...accounts];
    newAccounts[index].value = value;
    setAccounts(newAccounts);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <div className="max-w-3xl mx-auto pb-4 p-8 rounded-xl shadow-sm">
          {/* 1. Appeal Background */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              1 Appeal Background <span className="text-red-500">*</span>
            </h2>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              *Please note:
              <br />
              1. Claimants must create a new account or log into their own
              account in order to submit an inheritance claim. Please do not
              submit an inheritance claim while signed into the deceased’s
              account.
              <br />
              2. Please provide notarized or documents certified as true copies
              by a licensed lawyer, with English translations (if the original
              documents are not in English).
            </p>
          </div>

          {/* 2. Deceased User Info */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              2 Deceased User’s Tillionx Account Information{" "}
              <span className="text-red-500">*</span>
            </h2>
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
              Please provide the deceased user&apos;s Tillionx ID, email, or
              mobile number. Providing only one of them is enough.
            </p>

            <div className="space-y-3">
              {accounts.map((account, index) => (
                <div key={index} className="flex gap-3 items-center">
                  <Select
                    value={account.type}
                    onChange={(val) => handleTypeChange(index, val)}
                    data={["Email", "Mobile", "UserID"]}
                    className="w-40"
                    placeholder="Select type"
                  />
                  <TextInput
                    placeholder="Account number"
                    value={account.value}
                    onChange={(e) => handleValueChange(index, e.target.value)}
                    className="flex-1"
                  />

                  {/* Show only one icon per row */}
                  {index === accounts.length - 1 ? (
                    // Last row → Plus button
                    <button
                      type="button"
                      onClick={addAccount}
                      className="p-2 bg-slate-200 border rounded-full hover:bg-slate-300"
                    >
                      <IconPlus size={18} />
                    </button>
                  ) : (
                    // Other rows → Minus button
                    <button
                      type="button"
                      onClick={() => removeAccount(index)}
                      className="p-2 bg-slate-200 border rounded-full hover:bg-slate-300"
                    >
                      <IconMinus size={18} />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* 3. Additional materials */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              3 Additional materials <span className="text-red-500">*</span>
            </h2>
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
              1. Certified true copy of last Will/Letter of
              Administration/Certificate of Inheritance/Grant of Probate/other
              legal documents establishing your right to claim the deceased’s
              assets
              <br />
              2. Certified true copy of the deceased’s Death Certificate
              <br />
              3. Certified true copy of the deceased’s government-issued
              identification document
              <br />
              4. Certified true copy of your government-issued identification
              documents
            </p>

            <FileInput
              placeholder="Upload file"
              multiple
              accept="image/png,image/jpeg,video/mp4,video/x-msvideo"
              className="mb-2"
            />
            <p className="text-xs text-gray-500">No more than 20 files.</p>
            <p className="text-xs text-gray-500">
              File size cannot exceed 30MB.
            </p>
            <p className="text-xs text-gray-500">
              Supported file formats are .jpg/.jpeg/.png/.mp4/.mov/.rmvb.
            </p>
            <p className="text-xs text-gray-500">
              Please do not upload an encrypted file.
            </p>
          </div>

          {/* 4. Additional Info */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              4 Additional Information <span className="text-red-500">*</span>
            </h2>
            <Textarea
              placeholder="Please describe your inheritance claim..."
              minRows={10}
            />
          </div>

          {/* Submit button */}
          <div className="flex justify-between items-center gap-10">
            <Button fullWidth size="md" variant="filled" color="gray">
              Cancel
            </Button>
            <Button fullWidth size="md" variant="filled" color="yellow">
              Submit
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Inheritance;
